export enum ResourceType {
    Vim = 'Vim',
    MP = 'MP'
}
